import ExportsRepository from 'repositories/CurrentUser/ExportsRepository';

const createBackgroundExportJob = (attributes) =>
  ExportsRepository.create(attributes).then(({ exportJob }) => exportJob);

const showBackgroundExportJob = (id) => ExportsRepository.show(id).then(({ exportJob }) => exportJob);

export default () => ({ createBackgroundExportJob, showBackgroundExportJob });
